const translations = {
    requiredError: 'Service item is required',
    serviceItemNotFound: 'Service item not found'
};

export default translations;
